<template>
  <div class="message-card">
    <!-- 卡片头部 -->
    <div class="msg-card-header">
      <span class="card-title">{{ $t('workbench.todoAndMessage') }}</span>
      <span class="header-tag">{{ $t('workbench.realtimeReminder') }}</span>
    </div>

    <!-- 内容区域 -->
    <div class="msg-card-content">
      <!-- 消息区域 -->
      <div class="section">
        <div class="section-title" style="color: #f45151">
          <span>{{ $t('workbench.message') }}</span>
          <span class="section-count">{{
            '(' + messageList.length + ')'
          }}</span>
        </div>
        <div
          class="section-carousel"
          ref="messageCarousel"
          v-if="messageList && messageList.length > 0"
        >
          <div class="marquee-wrapper">
            <div
              class="carousel-track message-track"
              :class="{ 'is-scrolling': messageList.length > 1 }"
            >
              <div
                v-for="(item, index) in messageList.length > 1
                  ? [...messageList, ...messageList]
                  : messageList"
                :key="'msg-' + index"
                class="carousel-item"
                @click="handleItemClick(item)"
              >
                <span class="item-text">{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">{{ $t('workbench.noMessage') }}</div>
      </div>

      <!-- 任务区域 -->
      <div class="section">
        <div class="section-header">
          <div class="section-title" style="color: #f4b13e">
            <span>{{ $t('workbench.task') }}</span>
            <span class="section-count" style="color: #f4b13e">{{
              '(' + taskList.length + ')'
            }}</span>
          </div>
        </div>
        <div
          class="section-carousel"
          ref="taskCarousel"
          v-if="taskList && taskList.length > 0"
        >
          <div class="marquee-wrapper">
            <div
              class="carousel-track task-track"
              :class="{ 'is-scrolling': taskList.length > 1 }"
            >
              <div
                v-for="(item, index) in taskList.length > 1
                  ? [...taskList, ...taskList]
                  : taskList"
                :key="'task-' + index"
                class="carousel-item"
                @click="handleTaskItemClick(item)"
              >
                <span class="item-text">{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">{{ $t('workbench.noTask') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageList } from '@/api/qg/workbench-component'
export default {
  name: 'MessageCard',
  data() {
    return {
      messageList: [],
      taskList: []
    }
  },
  created() {
    this.getMessageList()
  },
  methods: {
    getMessageList() {
      getMessageList({
        closedLoopFlag: 0
      }).then((res) => {
        this.messageList = (res.data?.result || []).map((item) => ({
          id: item.originId,
          type: 'message',
          text: item.msgContext,
          date: this.formatDate(item.createTime),
          routers: item.routers
        }))
      })
      getMessageList({
        closedLoopFlag: 1
      }).then((res) => {
        this.taskList = (res.data?.result || []).slice(0, 5).map((item) => ({
          id: item.originId,
          type: 'task',
          text: item.msgContext,
          date: this.formatDate(item.createTime),
          routers: item.routers
        }))
      })
    },
    formatDate(dateStr) {
      if (!dateStr) return this.$t('workbench.today')
      const now = new Date()
      const date = new Date(dateStr.replace(/-/g, '/'))
      const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24))
      if (diffDays === 0) return this.$t('workbench.today')
      if (diffDays === 1) return this.$t('workbench.yesterday')
      if (diffDays < 7) return `${diffDays}${this.$t('workbench.daysAgo')}`
      return dateStr.split(' ')[0]
    },
    handleTaskItemClick(item) {
      const router =
        item.routers && item.routers.length > 0
          ? item.routers[item.routers.length - 1]
          : {}
      router.path &&
        this.$router.push({
          path: router.router,
          query: {
            orderType: router.extra?.orderType || '',
            orderNo: router.extra?.orderNo || '',
            orderTypeParam: router.extra?.orderTypeParam || ''
          }
        })
    },
    handleItemClick(item) {
      console.log('点击了:', item)
      this.$router.push({
        path: 'messageCenter/messageLog/messageSendingDetail',
        query: {
          oid: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 12px;
}
.message-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
}

.msg-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .card-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 14px;
    color: #333333;
  }

  .header-tag {
    font-weight: 300;
    font-size: 12px;
    color: #cccccc;
    line-height: 12px;
  }
}

.msg-card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section {
  height: 40px;
  background: #f7f8fc;
  border-radius: 8px;
  padding: 10px 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;

  .section-title {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #333333;
    font-weight: 600;

    .message-icon {
      color: #f35252;
      font-size: 14px;
    }

    .task-icon {
      color: #fb923c;
      font-size: 14px;
    }

    .section-count {
      color: #f35252;
      font-weight: 600;
    }
  }

  .section-badge {
    font-size: 11px;
    color: #999999;
  }

  .section-carousel {
    height: 20px;
    overflow: hidden;
    position: relative;
    flex: 1;

    .marquee-wrapper {
      height: 100%;
      overflow: hidden;
    }

    .carousel-track {
      display: flex;
      flex-direction: column;

      &.is-scrolling {
        animation: marquee-up 10s linear infinite;
      }

      .carousel-item {
        height: 20px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #595959;
        letter-spacing: 0;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;

        .item-text {
          font-size: 13px;
          color: #333333;
          line-height: 20px;
        }
      }
    }
  }
}

@keyframes marquee-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>
